/* MELYR: on desktop, show the fit notes and mauve trust box under the product photos instead of in the right column.
   Also marks the colour swatch for the product you are on (class m-current). */
(function(){
  function markSwatch(){
    var links=document.querySelectorAll('[class^="variants-body-template"]>a');
    for(var i=0;i<links.length;i++){
      var on=links[i].pathname&&location.pathname.slice(-links[i].pathname.length)===links[i].pathname;
      if(on&&!links[i].classList.contains('m-current')) links[i].classList.add('m-current');
    }
  }
  function ensure(){
    markSwatch();
    var product=document.querySelector('.product');
    if(!product) return;
    var info=product.querySelector('.product-info');
    if(!info) return;
    var trust=info.querySelector('.m-pdp-trust2');
    if(!trust) return;
    var gallery=product.querySelector(':scope > product-gallery');
    if(!gallery) return;
    var slot=product.querySelector(':scope > .m-trust-slot');
    var fit=info.querySelector('.m-pdp-fit');
    var human=info.querySelector('.m-pdp-human');
    var html=(fit?fit.outerHTML:'')+trust.outerHTML+(human?human.outerHTML:'');
    if(!slot){
      slot=document.createElement('div');
      slot.className='m-trust-slot';
      gallery.insertAdjacentElement('afterend',slot);
    }
    if(slot.innerHTML!==html) slot.innerHTML=html;
    product.classList.add('m-has-trust-slot');
  }
  var t;
  function soon(){clearTimeout(t);t=setTimeout(ensure,50);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ensure); else ensure();
  new MutationObserver(function(ms){
    for(var i=0;i<ms.length;i++){if(!ms[i].target.closest||!ms[i].target.closest('.m-trust-slot')){soon();return;}}
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* MELYR: mobile product photos. Adds left and right arrows so it is clear there are more photos to swipe through. */
(function(){
  function css(){
    if(document.getElementById('m-gnav-css')) return;
    var s=document.createElement('style');s.id='m-gnav-css';
    s.textContent=
      'product-gallery{position:relative}'+
      '.m-gnav{position:absolute;left:0;right:0;pointer-events:none;z-index:2;display:none}'+
      '@media (max-width:699px){.m-gnav{display:block}}'+
      '.m-gnav button{pointer-events:auto;position:absolute;top:50%;transform:translateY(-50%);width:30px;height:30px;border-radius:50%;border:0;background:rgba(255,255,255,.88);box-shadow:0 1px 4px rgba(7,3,41,.18);display:grid;place-items:center;padding:0;cursor:pointer;-webkit-tap-highlight-color:transparent}'+
      '.m-gnav button svg{width:12px;height:12px;stroke:#070329;stroke-width:2.2;fill:none}'+
      '.m-gnav button::after{content:"";position:absolute;inset:-8px}'+
      '.m-gnav .m-prev{left:10px}.m-gnav .m-next{right:10px}'+
      '.m-gnav button[hidden]{display:none}'+
      '@media (min-width:700px){.product-sticky-bar{background:#fff}}'+
      'html body .jm-star-rating__font-icon{font-family:JudgemeStar,monospace!important}';
    document.head.appendChild(s);
  }
  var chev=function(d){return '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="'+(d<0?'M10 3 5 8l5 5':'M6 3l5 5-5 5')+'"/></svg>';};
  function setup(g){
    if(g.querySelector(':scope > .m-gnav')) return;
    var c=g.querySelector('scroll-carousel');
    if(!c||typeof c.next!=='function') return;
    var n=document.createElement('div');n.className='m-gnav';
    n.innerHTML='<button type="button" class="m-prev" aria-label="Previous photo">'+chev(-1)+'</button><button type="button" class="m-next" aria-label="Next photo">'+chev(1)+'</button>';
    g.appendChild(n);
    var prev=n.querySelector('.m-prev'),next=n.querySelector('.m-next');
    function total(){try{return c.cells.length}catch(e){return c.children.length}}
    function index(){try{return c.selectedIndex||0}catch(e){return 0}}
    function place(){
      var gr=g.getBoundingClientRect(),cr=c.getBoundingClientRect();
      n.style.top=(cr.top-gr.top)+'px';n.style.height=cr.height+'px';
    }
    function update(){
      var t=total(),i=index();
      if(t<2){n.style.display='none';return}
      n.style.display='';
      place();
    }
    prev.addEventListener('click',function(){var i=index(),t=total();if(i<=0){c.select(t-1)}else{c.previous()}setTimeout(update,350)});
    next.addEventListener('click',function(){var i=index(),t=total();if(i>=t-1){c.select(0)}else{c.next()}setTimeout(update,350)});
    ['carousel:change','carousel:select','carousel:settle','scrollend'].forEach(function(ev){c.addEventListener(ev,function(){setTimeout(update,30)})});
    var st;c.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(update,120)},{passive:true});
    if(window.ResizeObserver) new ResizeObserver(place).observe(c);
    update();
  }
  function run(){css();document.querySelectorAll('product-gallery').forEach(setup)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  window.addEventListener('load',run);
  var rt;new MutationObserver(function(){clearTimeout(rt);rt=setTimeout(run,100)}).observe(document.documentElement,{childList:true,subtree:true});
})();
